import { render, staticRenderFns } from "./purchasesReturnsGathering.vue?vue&type=template&id=4fde95cf&scoped=true&"
import script from "./purchasesReturnsGathering.vue?vue&type=script&lang=js&"
export * from "./purchasesReturnsGathering.vue?vue&type=script&lang=js&"
import style0 from "./purchasesReturnsGathering.vue?vue&type=style&index=0&id=4fde95cf&lang=less&scoped=true&"
import style1 from "./purchasesReturnsGathering.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fde95cf",
  null
  
)

component.options.__file = "purchasesReturnsGathering.vue"
export default component.exports